<template>
    <b-navbar class="is-dark">
        <template #brand>
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <p class="title has-text-success">GREENSTACKS.</p>
            </b-navbar-item>
        </template>
        <template #end>
            <b-navbar-item>
                <p v-if="$store.state.authUser">Signed in as {{$store.state.authUser.email}}</p>
            </b-navbar-item>
            <b-navbar-item>
                <b-button :to="{name: 'Login' }" class="mr-3" tag="router-link" type="is-light"
                          v-if="!$store.state.authUser">
                    Login
                </b-button>
                <b-button @click="signOut" v-else type="is-danger">
                    Log Out
                </b-button>
            </b-navbar-item>

        </template>
    </b-navbar>
</template>

<script>
    import firebase from 'firebase/app'
    import 'firebase/auth'

    export default {
        name: "Navigation",
        methods: {
            signOut() {
                firebase.auth().signOut();
                window.location.reload();
            }
        }
    }
</script>

<style scoped>

</style>